











































































































































import { Component, Vue } from "vue-property-decorator";
import Sparkline from "vue-sparklines";
import { Store } from "vuex";
import { Share } from "@/interfaces";
import { store } from "@/store";
import { readHasAdminAccess } from "@/store/main/getters";
import { readMiners, readOneMiner } from "@/store/main/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import { dispatchGetUsers } from "@/store/admin/actions";

import { Currency } from "@/interfaces";
import {  readCurrencies } from "@/store/wallet/getters";

import {
  dispatchGetMiners,
  dispatchGetSharesByMiner
} from "@/store/main/actions";
import { dispatchGetCurrencies } from "@/store/wallet/actions";

@Component({
  components: {
    Sparkline
  }
})
export default class Miners extends Vue {
  public headers = [
    {
      text: "نام",
      sortable: true,
      value: "name",
      align: "right"
    },
    {
      text: "ارز",
      sortable: true,
      value: "currency",
      align: "right"
    },
    {
      text: "نرخ هش اعلامی",
      sortable: true,
      value: "hashrate",
      align: "right"
    },
    {
      text: "نرخ هش واقعی",
      sortable: true,
      value: "calculated_hashrate",
      align: "right"
    },
    {
      text: "نام کاربری",
      sortable: true,
      value: "username",
      align: "right"
    },
    {
      text: "آخرین فعالیت",
      sortable: true,
      value: "modified",
      align: "right"
    },
    {
      text: "فعال",
      sortable: true,
      value: "is_active",
      align: "right"
    },
    {
      text: "سهم های معتبر",
      sortable: true,
      value: "valid_shares",
      align: "right"
    },
    {
      text: "سهم های نامعتبر",
      sortable: true,
      value: "invalid_shares",
      align: "right"
    },
    {
      text: "تاریخ اولین اتصال",
      sortable: true,
      value: "created",
      align: "right"
    },
    {
      text: "نمودار",
      value: "shares",
      align: "right"
    },
    {
      text: "عملیات",
      value: "edit",
      align: "right"
    }
  ];

  public spIndicatorStyles = true;
  public spLineStyles1 = {
    stroke: "#00a000ff"
  };
  public spLineStyles2 = {
    stroke: "#0000ffff"
  };
  public spLineStyles3 = {
    stroke: "#ff0000ff"
  };

  public fetched = false;

  total_shares = 0;
  total_hashrate = 0;
  get miners() {
    const miners = readMiners(this.$store);
    this.total_shares = 0;
    this.total_hashrate = 0;
    miners.forEach(miner => {
      this.total_shares += miner.valid_shares;
      this.total_shares += miner.stale_shares;
      this.total_shares += miner.invalid_shares;
      if (miner.hashrate) this.total_hashrate += miner.hashrate;
    });
    return miners;
  }

  public getUserName(user_id: number) {
    const user = readAdminOneUser(this.$store)(user_id);
    if (!user) {
      return "----";
    }
    let name = user.id.toString() + "-";
    if (user.full_name) name += user.full_name;
    else if (user.mobile) name += user.mobile;
    else if (user.email) name += user.email;

    return name;
  }

  getShares(shares: Share[]) {
    if (!shares) return [[], [], []];
    const shares_chart: number[][] = [[], [], []];
    for (const share of shares) {
      shares_chart[0].push(share.valid_count);
      shares_chart[1].push(share.stale_count);
      shares_chart[2].push(share.invalid_count);
    }
    return shares_chart;
  }

  getHashrate(hashrate: number, currency_id: number) {
    const percent = (hashrate / this.total_hashrate) * 100;
    let unit = "MH";
    let fix_number = 2;
    let power_number = 6;
    if(this.getCurrencyName(currency_id) == "XCC" ||  this.getCurrencyName(currency_id) == "XCH"){
      unit = "TB";
      fix_number = 5;
      power_number = 12;
    }
    return (hashrate / 10 ** power_number).toFixed(fix_number) +unit+ "(" + percent.toFixed(1) + "%)";
  }

  summerize(str) {
    if (!str) {
      str = "----";
    }
    if (str?.length > 14) {
      str = str?.substring(0, 11) + "...";
    }
    return str;
  }

  lastseen(date: string) {
    const now = new Date();
    const modified = new Date(date + "Z");

    console.log(now, modified, date);
    return `${((now.getTime() - modified.getTime()) / 10 ** 3).toFixed(0)}s`;
  }

  showPercent(shares: number, total: number) {
    const percent = (shares / total) * 100;
    return `${shares}(${percent.toFixed(1)}%)`;
  }

  public getCurrencyName(currency_id: number) {
    return readCurrencies(this.$store).find(
      (currency: Currency) => currency.id === currency_id
    )!.name;
  }

  public async mounted() {
    await dispatchGetMiners(this.$store);
    await dispatchGetCurrencies(this.$store);

    const promises: Promise<void>[] = [];
    for (const miner of readMiners(this.$store)) {
      promises.push(
        (async () => {
          await dispatchGetSharesByMiner(this.$store, {
            minerId: miner.id,
            limit: 30,
            offset: 0
          });
        })()
      );
    }
    if (readHasAdminAccess(store)) {
      promises.push(dispatchGetUsers(this.$store));
      this.headers.splice(0, 0, {
        text: "ID",
        sortable: true,
        value: "id",
        align: "right"
      });
      this.headers.splice(5, 0, {
        text: "کاربر",
        sortable: true,
        value: "owner_id",
        align: "right"
      });
    }
    await Promise.allSettled(promises);

    this.fetched = true;
  }
}
